import styled from 'styled-components/native';
import TextInput from '../../components/TextInput';

export const Field = styled(TextInput)`
  padding: 10px 15px;
  background: rgba(255, 255, 255, 1.0);
  width: 100%;
`;
